import { render, staticRenderFns } from "./patrolEquip.vue?vue&type=template&id=58598f71&scoped=true&"
import script from "./patrolEquip.vue?vue&type=script&lang=ts&"
export * from "./patrolEquip.vue?vue&type=script&lang=ts&"
import style0 from "./patrolEquip.vue?vue&type=style&index=0&id=58598f71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58598f71",
  null
  
)

export default component.exports